module.exports = __webpack_public_path__ + "img/40393444.a6639c55.png";